function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "60",
  height: "60",
  viewBox: "0 0 60 60",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M35.657 3.13L56.87 24.343a8 8 0 010 11.314L35.657 56.87a8 8 0 01-11.314 0L3.13 35.657a8 8 0 010-11.314L24.343 3.13a8 8 0 0111.314 0zM30 40a4 4 0 100 8 4 4 0 000-8zm0-28a4 4 0 00-4 4v16a4 4 0 108 0V16a4 4 0 00-4-4z",
  fill: "#C53030",
  fillRule: "evenodd"
})));